'use client';
import * as React from 'react';
import { useCardFooter_unstable } from './useCardFooter';
import { renderCardFooter_unstable } from './renderCardFooter';
import { useCardFooterStyles_unstable } from './useCardFooterStyles.styles';
import { useCustomStyleHook_unstable } from '@fluentui/react-shared-contexts';
/**
 * Component to render Button actions in a Card component.
 */ export const CardFooter = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const state = useCardFooter_unstable(props, ref);
    useCardFooterStyles_unstable(state);
    useCustomStyleHook_unstable('useCardFooterStyles_unstable')(state);
    return renderCardFooter_unstable(state);
});
CardFooter.displayName = 'CardFooter';
